import usersApi from './api';
import usersToasts from './toasts';
import userGroupsApi from '../groups/sagas/api';
import userGroupsLayout from '../groups/sagas/layout';
import userGroupsToasts from '../groups/sagas/toasts';
import userSharingToasts from '../membership/sagas/toasts';

export default [
  usersApi(),
  usersToasts(),
  userGroupsApi(),
  userGroupsLayout(),
  userGroupsToasts(),
  userSharingToasts(),
];
